'use strict';

class dynamicCheckboxLabel {
  constructor(elem) {
    this.elem = elem;
    this.inputCheckbox = this.elem.querySelector('.js-input-checkbox');
    this.dynamicLabel = this.elem.querySelector('.js-dynamic-label-text');
    this.defaultLabel = `${this.dynamicLabel.textContent}`;
    this.updatedLabel = this.dynamicLabel.getAttribute('data-dynamiclabel-updatedlabel');
    this.events()
  }

  events() {
    this.inputCheckbox.addEventListener('change', (event) => {
      this.dynamicLabel.textContent = event.target.checked ? this.updatedLabel : this.defaultLabel;
      this.dynamicLabel.classList.toggle('icon-check-main');
    });
  }
}

const dynamicLabels = document.querySelectorAll('.js-dynamic-label');

for (let dynamicLabel of dynamicLabels) {
  dynamicLabel.collapse = new dynamicCheckboxLabel(dynamicLabel)
}
